/**
 * Hubリスナーを管理する
 *
 * シングルサインオンを用いたログインでは
 * IDプロバイダーでの認証後に専用のページにリダイレクトされ、自動でamplify側でトークンを取得する処理を行うため、
 * ログイン処理の実装側でエラーのcatchができない
 * そのため、amplify側で行う認証処理をlistenすることができるHub.listenを使用してamplify側の処理で起きたエラーを検知する
 */

import { Hub, HubCapsule } from '@aws-amplify/core';

const CHANNEL = 'auth';

/**
 * @deprecated
 * テストで毎回初期化されたインスタンスを使用するため、例外的にexportして外から呼び出せるようにする
 */
export class HubManager {
    private cacheListener?: (data: HubCapsule) => void;

    /**
     * リスナーを登録する
     * remove時に同じ参照の関数を渡す必要があるため、関数を保持しておく
     */
    registerHubListener = (callback: (data: HubCapsule) => void) => {
        if (this.cacheListener) {
            Hub.remove(CHANNEL, this.cacheListener);
        }

        this.cacheListener = callback;
        Hub.listen(CHANNEL, this.cacheListener);
    };

    /**
     * リスナーを削除する
     */
    removeHubListener = () => {
        if (this.cacheListener) {
            Hub.remove(CHANNEL, this.cacheListener);
        }
    };
}

export const { registerHubListener, removeHubListener } = new HubManager();
